import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-solid",
  "use": "icon-down-solid-usage",
  "viewBox": "0 0 14 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 7\" id=\"icon-down-solid\">\r\n  <path id=\"icon-down-solid_多边形_1\" data-name=\"多边形 1\" d=\"M6.823.177a.25.25,0,0,1,.354,0l6.4,6.4A.25.25,0,0,1,13.4,7H.6a.25.25,0,0,1-.177-.427Z\" transform=\"translate(14 7) rotate(180)\" fill=\"#333\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol